import type { ReactNode } from 'react'
import { apiAssetUrl } from '../../config'

export type ClientRow = {
  id: number
  name: string
  industry: string | null
  description?: string | null
  website_url?: string | null
  logo_path?: string | null
  logo_stored_path?: string | null
  is_active: number
  sort_order: number
}

export type ClientDetail = ClientRow

export function StatusBadge({ active }: { active: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide ${
        active ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'
      }`}
    >
      {active ? 'Active' : 'Hidden'}
    </span>
  )
}

export function LogoThumb({ path, name }: { path?: string | null; name?: string }) {
  if (!path) {
    const initials = (name || '?')
      .split(/\s+/)
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase()
    return (
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 border border-primary/10 text-xs font-bold text-primary">
        {initials || '?'}
      </div>
    )
  }
  return (
    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-primary/10 bg-white p-1">
      <img src={apiAssetUrl(path)} alt="" className="max-h-full max-w-full object-contain" />
    </div>
  )
}

export function IconAction({
  children,
  label,
  onClick,
  danger,
}: {
  children: ReactNode
  label: string
  onClick: () => void
  danger?: boolean
}) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-xl border transition active:scale-95 ${
        danger
          ? 'border-red-200 bg-red-50 text-red-600 hover:bg-red-100'
          : 'border-primary/15 bg-white text-primary hover:bg-primary/[0.06]'
      }`}
    >
      {children}
    </button>
  )
}
